export default __webpack_public_path__ + "static/media/Quarto-Light.b6f48f9c.woff2";